export type AppCrashedActions = AppCrashed;

export function appCrashed(
  technicalErrorMessage: string,
  error?: Record<string, unknown>,
  sendAutomaticEmail?: boolean,
) {
  return {
    type: 'APP_CRASHED' as const,
    technicalErrorMessage,
    error,
    sendAutomaticEmail,
  };
}

export type AppCrashed = ReturnType<typeof appCrashed>;
